import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { Carousel, Button, Alert } from "react-bootstrap";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

import Header from "../common/Header";
import Footer from "../common/Footer";
import Reviews from "./Reviews";

const Home = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      offset: 100,
    });
  }, []);

  return (
    <div className="homeContainer">
      <Helmet>
        <title>
          Era Salon Citrus Heights | Best Hair Salon & Nail Spa | (916) 722-1888
        </title>
        <meta
          name="description"
          content="Era Salon in Citrus Heights, CA offers professional hair styling, coloring, highlights, nail care, waxing, and facial services. Licensed stylists, competitive pricing. Book your appointment today at (916) 722-1888!"
        />
        <meta
          name="keywords"
          content="hair salon Citrus Heights, nail salon Sacramento, hair coloring Citrus Heights, nail care, hair styling, Brazilian wax, manicure pedicure, facial care, hair highlights, perm services, Era Salon"
        />
        <meta name="author" content="Era Salon" />
        <meta name="robots" content="index, follow" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <link rel="canonical" href="https://erasalon.com/" />
        <meta property="og:title" content="Era Salon Citrus Heights | Best Hair Salon & Nail Spa" />
        <meta property="og:description" content="Professional hair styling, coloring, nail care, waxing, and facial services in Citrus Heights, CA. Book your appointment today!" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://erasalon.com/" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Era Salon Citrus Heights | Best Hair Salon & Nail Spa" />
        <meta name="twitter:description" content="Professional hair styling, coloring, nail care, waxing, and facial services in Citrus Heights, CA." />
        <meta name="geo.region" content="US-CA" />
        <meta name="geo.placename" content="Citrus Heights" />
        <meta name="geo.position" content="38.7071;-121.2811" />
        <meta name="ICBM" content="38.7071, -121.2811" />
      </Helmet>
      <Header />
      <div className="carouselContainer">
        <div className="fluid-container">
          <Carousel fade interval={5000} pause="hover" transition="fade">
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={process.env.PUBLIC_URL + "/images/homeslider1.jpg"}
                alt="ERA SALON STAFF"
              />
              <Carousel.Caption>
                <h3>ERA SALON STAFF</h3>
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={process.env.PUBLIC_URL + "/images/homeslider2.jpg"}
                alt="ERA SALON FRONT"
              />
              <Carousel.Caption>
                <h3>ERA SALON FRONT</h3>
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={process.env.PUBLIC_URL + "/images/homeslider3.jpg"}
                alt="ERA SALON SERVICES"
              />
              <Carousel.Caption>
                <h3>ERA SALON SERVICES</h3>
                <p>
                  Friendly Staff, Quality Service, Competitive Pricing, Licensed
                  &amp; Certified
                </p>
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={process.env.PUBLIC_URL + "/images/homeslider4.jpg"}
                alt="Hair Coloring"
              />
              <Carousel.Caption>
                <h3>Hair Coloring</h3>
                <p>Your Beauty is our Business</p>
                <Link to="/hair-coloring">
                  <Button variant="primary">Hair Coloring</Button>
                </Link>
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={process.env.PUBLIC_URL + "/images/homeslider5.jpg"}
                alt="Hair Styling"
              />
              <Carousel.Caption>
                <h3>Hair Styling</h3>
                <Link to="/hair-styling">
                  <Button variant="primary">Click Here</Button>
                </Link>
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={process.env.PUBLIC_URL + "/images/homeslider6.jpg"}
                alt="Hair Texturing"
              />
              <Carousel.Caption>
                <h3>Hair Texturing</h3>
                <Link to="/hair-texturing">
                  <Button variant="primary">Click Here</Button>
                </Link>
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={process.env.PUBLIC_URL + "/images/homeslider7.jpg"}
                alt="MEN PROFESSIONAL HAIRCUT"
              />
              <Carousel.Caption>
                <h3>MEN PROFESSIONAL HAIRCUT</h3>
                <p>Cut Style &amp; Color</p>
              </Carousel.Caption>
            </Carousel.Item>
          </Carousel>
        </div>
      </div>
      <div className="container">
        <div className="homeServices my-5">
          <h1 className="py-3 text-center" data-aos="fade-up">
            Your Beauty is our Business
          </h1>

          <h2 data-aos="fade-up">
            <strong>Services</strong>
          </h2>

          <div className="row justify-content-center">
            <div className="col-lg-3 shadow-sm p-4 m-2" data-aos="fade-up" data-aos-delay="100">
              <h3>Hair Coloring/Highlights</h3>
              <p>
                Considering a completely new style is one thing but how else can
                you add zing to your locks?
              </p>
              <Link to="/hair-coloring" className="btn btn-primary">
                Read More
              </Link>
            </div>
            <div className="col-lg-3 shadow-sm p-4 m-2" data-aos="fade-up" data-aos-delay="200">
              <h3>Hair Straightening</h3>
              <p>
                "ERA SALON SAC" is always up to date on the latest and greatest.
                Your satisfaction is important to us.
              </p>
              <Link to="/hair-styling" className="btn btn-primary">
                Read More
              </Link>
            </div>
            <div className="col-lg-3 shadow-sm p-4 m-2" data-aos="fade-up" data-aos-delay="300">
              <h3>Nail Care</h3>
              <p>
                We aim to deliver premier service in an intimate, relaxed
                setting. Our friendly staff are here to assist you.
              </p>
              <Link to="/nail-care" className="btn btn-primary">
                Read More
              </Link>
            </div>
            <div className="col-lg-3 shadow-sm p-4 m-2" data-aos="fade-up" data-aos-delay="400">
              <h3>Microblading</h3>
              <p>
                We offer microblading services for customers that want the
                perfect brows. Have a specific request? Ask us anytime.
              </p>
            </div>
          </div>
        </div>

        <div className="specials">
          <h2 data-aos="fade-up">
            <strong>Browse Our Specials</strong>
          </h2>
          <div className="row">
            <Alert variant="info" data-aos="fade-up">
              <Alert.Heading>
                <i className="fas fa-info-circle fa-2x"></i>
              </Alert.Heading>
              <p>
                We currently only specialize in offering our brazilian waxing
                services to{" "}
                <strong style={{ textDecoration: "underline" }}>
                  females only
                </strong>{" "}
                and{" "}
                <strong style={{ textDecoration: "underline" }}>DO NOT</strong>{" "}
                offer any waxing services to males. We apologize for this
                inconvenience.
              </p>
            </Alert>
            <div className="col-lg-4" data-aos="fade-up" data-aos-delay="100">
              <div className="card shadow-sm">
                <div className="card-body">
                  <h5 className="card-title text-center">
                    <strong>Brazilian Wax (females only)</strong>
                  </h5>
                  <p className="card-text">
                    <img
                      src="/images/ERA-Brazilian.jpg"
                      alt="Era Salon Brazilian Wax"
                    />
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4" data-aos="fade-up" data-aos-delay="200">
              <div className="card shadow-sm">
                <div className="card-body">
                  <h5 className="card-title text-center">
                    <strong>FREE Haircut with Color Highlights or Perm</strong>
                  </h5>
                  <p className="card-text">
                    <img
                      src="/images/ERA-Hair-Color.jpg"
                      alt="Era Salon Haircut with Color"
                    />
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4" data-aos="fade-up" data-aos-delay="300">
              <div className="card shadow-sm">
                <div className="card-body">
                  <h5 className="card-title text-center">
                    <strong>Full Nail Set</strong>
                  </h5>
                  <p className="card-text">
                    <img
                      src="/images/ERA-Full-Nail.jpg"
                      alt="Era Salon Full Nail Set"
                    />
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Reviews */}
        <h2 data-aos="fade-up">
          <strong>Reviews</strong>
        </h2>
        <div className="row">
          <div className="col-12" data-aos="fade-up">
            <div className="reviewer">
              <p>
                "I LOVE MY HAIRCUT! And I love this salon! Jenny is the best
                hairstylist I have ever had. My mom always complains about my
                haircut but this time SHE LOVES IT! Today was my first time at
                Era Salon, but I am for sure going to this salon when every
                time I need to get my hair cut or even get my nails done! VERY
                RECOMMENDED"
              </p>
              <div className="rating text-center">
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
              </div>
              <div className="quoteName text-right">
                <strong>- R.F.</strong>
              </div>
            </div>
          </div>
        </div>
        {/* Reviews */}
        <Reviews />

        {/* Videos */}
        <div className="videos">
          <h2 data-aos="fade-up">
            <strong>Videos</strong>
          </h2>
          <div className="row">
            <div className="col-lg-6 shadow-sm" data-aos="fade-up" data-aos-delay="100">
              <video
                src="https://erasalonbucket.s3.us-west-1.amazonaws.com/Era_Salon.mp4"
                width="100%"
                height="315"
                allowFullScreen
                controls
                title="Era Salon Video First"
              ></video>
            </div>
            <div className="col-lg-6 shadow-sm" data-aos="fade-up" data-aos-delay="200">
              <video
                src="https://erasalonbucket.s3.us-west-1.amazonaws.com/Era_Salonvod2.mp4"
                width="100%"
                height="315"
                allowFullScreen
                controls
                title="Era Salon Video Second"
              ></video>
            </div>
            <div className="col-lg-6 shadow-sm" data-aos="fade-up" data-aos-delay="300">
              <iframe
                width="100%"
                height="315"
                src="https://www.youtube.com/embed/owMKb4xWjuI"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Home;
